import { Subject } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class AccountService {
    token: string;
    constructor() { }
    accountChanged: Subject<any> = new Subject();
}